<template>
  <v-container class="oboarding-page fill-height">
    <v-row align="center" justify="center" class="fill-height ma-0 px-0" no-gutters>
      <v-col cols="12" sm="9" md="7" lg="6" xl="4">
        <v-card class="py-8 px-4 px-sm-8">
          <v-row align="center" justify="center">
            <v-col cols="auto">
              <Logo class="if-logo" />
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="mb-6">
            <v-col cols="auto">
              <div v-if="!loginIsVerifyingEmail" class="text-uppercase text-center blue--text text--darken-3 mb-4">Vuoi partecipare a IF!Live 2021?</div>
              <div v-if="!loginIsVerifyingEmail" class="text-uppercase text-center blue--text text--darken-3 mb-4">Se possiedi già il biglietto prosegui con la registrazione o il login.</div>
              <v-btn v-if="!loginIsVerifyingEmail" block text tile href="https://www.mailticket.it/manifestazione/E931" rel="nofollow" target="_blank">Altrimenti acquista il biglietto&nbsp;<span class="text-decoration-underline blue--text text--lighten-4">qui.</span></v-btn>
              <div class="text-center" v-if="loginIsVerifyingEmail">Enter the code we provided you in your registration email</div>
            </v-col>
          </v-row>
          <v-row v-if="!loginIsVerifyingEmail" key="federatedsignin">
            <v-col cols="12">
              <v-btn block depressed rounded @click="$root.auth.federatedSignIn()" light large color="white"><GoogleLogo  class="google-logo mr-2" /><span class="font-family-proxima">Sign in with Google</span></v-btn>
            </v-col>
          </v-row>
          <v-row v-if="!loginIsVerifyingEmail" key="or">
            <v-col cols="12" class="text-center">
              <p>Or sign in with your email</p>
            </v-col>
          </v-row>
          <v-row key="loginform">
            <v-col cols="12">
              <LoginForm :precompiled-email="precompiledEmail" :precompiled-password="precompiledPassword" :verification-state.sync="loginIsVerifyingEmail" />
            </v-col>
          </v-row>
          <v-row v-if="!loginIsVerifyingEmail" key="signup">
            <v-col cols="12">
              <v-btn text depressed tile block class="" :to="{name: 'Register', params: {language: $language.current}}">I don't have an account,&nbsp;<span class="text-decoration-underline blue--text text--lighten-4">Sign Up</span></v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GoogleLogo from '@/assets/img/google_logo.svg'
import Logo from '@/assets/img/logo.svg'
import LoginForm from '@/molecules/LoginForm.vue'

export default {
  name: 'OnboardingPage',
  data () {
    return {
      loginIsVerifyingEmail: false
    }
  },
  props: {
    precompiledEmail: {
      type: String,
      required: false
    },
    precompiledPassword: {
      type: String,
      required: false
    }
  },
  components: {
    Logo,
    GoogleLogo,
    LoginForm
  }
}
</script>

<style lang="scss" scoped>
.google-logo {
  width: 30px;
  height: 30px;
}
</style>
